import { render, staticRenderFns } from "./CandleChart.vue?vue&type=template&id=e06b35b4&scoped=true&"
import script from "./CandleChart.vue?vue&type=script&lang=ts&"
export * from "./CandleChart.vue?vue&type=script&lang=ts&"
import style0 from "./CandleChart.vue?vue&type=style&index=0&id=e06b35b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06b35b4",
  null
  
)

export default component.exports